import { observable, action, makeObservable } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { FulfillmentOrderService, HistoryLogService } from 'common/data';
import _ from 'lodash';

class FulfillmentOrderStore extends BaseStore {
	@observable items = null;

	constructor(rootStore) {
		super(new FulfillmentOrderService(rootStore.app.baasic.apiClient));
		makeObservable(this);
		this.historyLogService = new HistoryLogService(rootStore.app.baasic.apiClient);
	}

	@action
	findFulfillmentOrder = async filter => {
		const response = await this.service.find(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
		return response.data;
	};

	@action
	findFulfillmentOrderHistoryLog = async filter => {
		const response = await this.historyLogService.find(filter);
		_.each(response.data.item, responseItem => {
			responseItem.changed = JSON.parse(responseItem.changed);
		});
		this.response = response.data;
	};

	@action
	getCloseoutOrders = async filter => {
		const response = await this.service.getCloseoutOrders(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
		return this.response;
	};

	@action
	getFulfillmentOrder = async (id, options) => {
		const response = await this.service.get(id, options);
		this.item = response.data;
		return response.data;
	};

	@action
	getFulfillmentOrdersForLabeling = async filter => {
		const response = await this.service.getFulfillmentOrdersForLabeling(filter);
		this.response = response.data;
		return response.data;
	};

	@action
	toggleProductionMode = async (id, productionMode, sourceOfChange) => {
		await this.service.toggleProductionMode(id, productionMode, sourceOfChange);
	};

	@action
	getFulfillmentOrders = async filter => {
		const fulfillmentOrder = await this.service.select(filter);
		this.items = fulfillmentOrder.data;
		return this.items;
	};

	@action
	countFulfillmentOrdersByStatus = async filter => {
		const response = await this.service.countFulfillmentOrdersByStatus(filter);
		this.response = response.data;
	};

	@action
	updateBuyShippingBulk = async (resource, sourceOfChange) => {
		const response = await this.service.updateBuyShippingBulk(resource, sourceOfChange);
		return response.data;
	};

	@action
	scanLabel = async (resource, sourceOfChange) => {
		await this.service.scanLabel(resource, sourceOfChange);
	};

	@action
	cancelFulfillmentOrder = async (resource, sourceOfChange) => {
		await this.service.cancelFulfillmentOrder(resource, sourceOfChange);
	};

	@action
	updateFulfillmentOrder = async (resource, sourceOfChange) => {
		await this.service.update(resource, sourceOfChange);
	};

	@action
	onHold = async (onHoldParams, sourceOfChange) => {
		const response = await this.service.onHold(onHoldParams, sourceOfChange);
		return response.data;
	};

	@action
	onHoldBulk = async (onHoldBulkParams, sourceOfChange) => {
		const response = await this.service.onHoldBulk(onHoldBulkParams, sourceOfChange);
		return response.data;
	};

	@action
	undoPackaged = async (undoPackageParams, sourceOfChange) => {
		const response = await this.service.undoPackaged(undoPackageParams, sourceOfChange);
		return response.data;
	};

	@action
	createWarehouseOrders = async fulfillmentOrderIds => {
		await this.service.createWarehouseOrders(fulfillmentOrderIds);
	};

	@action
	validateOrderAddress = async order => {
		var response = await this.service.validateOrderAddress(order);
		this.item = response.data;
		return response.data;
	};

	@action
	reoptimize = async (reoptimizeParams, sourceOfChange) => {
		var response = await this.service.reoptimize(reoptimizeParams, sourceOfChange);
		this.item = response.data;
		return response.data;
	};

	@action
	changeWarehouseShipByDate = async (payload, sourceOfChange) => {
		const response = await this.service.changeWarehouseShipByDate(payload, sourceOfChange);
		this.item = response.data;
		return response.data;
	};
}

export default FulfillmentOrderStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/FulfillmentOrderStore.js